<ion-card class="vesta-info-card ion-no-margin ion-margin-bottom"
          [ngClass]="{ 'vesta-info-card--success': success }"
          *ngIf="message" >
    <ion-icon class="vesta-info-card__icon"
              [ngClass]="{ 'vesta-info-card__icon--success': success }"
              name="close-outline"
              (click)="close();"></ion-icon>
    <ion-card-header>
        {{ message.header }}
    </ion-card-header>
    <ion-card-content>
        {{ message.message }}
    </ion-card-content>
</ion-card>
